import { isVideoFile } from './file';
import { StoryAnimation } from '../enums';
import {
  AdditionalProductFragment,
  FileFragment,
  StoryFragment,
  StoryModuleFragment,
  VariantFragment,
} from '../graphql/generated/graphql';
import { Story, StoryComponent } from '../types';
import { isSomething } from './something';

export const storyAnimationsImplyVideo = (animations?: StoryAnimation[]) => {
  if (!animations) return false;
  return (
    animations.includes(StoryAnimation.Autoplay) ||
    animations.includes(StoryAnimation.OnHover)
  );
};

export const getVideo = (story: Story): FileFragment | undefined => {
  const firstStoryPage = story.StoryPages?.[0];
  const media = firstStoryPage?.Media;

  if (media && isVideoFile(media)) {
    return media;
  }
};

export const isStory = (value: StoryFragment): value is Story => {
  if (!value.locale) return false;
  if (!value.PreviewImage) return false;
  if (!value.Slug) return false;
  return true;
};

export const isStoryComponent = (
  value: NonNullable<StoryModuleFragment['Content']>[0]
): value is StoryComponent => {
  if (!value) return false;
  if (value.__typename !== 'ComponentContentStory') return false;
  if (!value.Story) return false;
  return true;
};

export const getAdditionalProducts = (
  story?: Story
): (AdditionalProductFragment & {
  selectedVariant?: VariantFragment | null;
})[] => {
  const firstStoryPage = story?.StoryPages?.[0];
  const components = firstStoryPage?.CallToAction?.map((component) =>
    component?.__typename === 'ComponentContentAdditionalProduct'
      ? component
      : undefined
  );
  return (
    components
      ?.map((c) =>
        c?.Additional_product
          ? { ...c.Additional_product, selectedVariant: c.Selected_variant }
          : undefined
      )
      .filter(isSomething) || []
  );
};
